type StrapiMediaTypes = '.jpg' | '.png'
type StrapiMediaMimeTypes = 'image/png' | 'image/jpeg'
type StrapiMediaFormat = {
  ext: StrapiMediaMimeTypes
  hash: string
  height: number
  mime: StrapiMediaMimeTypes
  name: string
  size: number
  url: string
  width: number
}
type StrapiMediaFormats = {
  medium: StrapiMediaFormat
  small: StrapiMediaFormat
  thumbnail: StrapiMediaFormat
  large?: StrapiMediaFormat
}
export type StrapiMedia = {
  alternativeText: string
  caption: string
  createdAt: string
  ext: StrapiMediaTypes
  formats: StrapiMediaFormats
  hash: string
  height: number
  mime: StrapiMediaMimeTypes
  name: string
  previewUrl: null
  provider: string
  provider_metadata: null
  size: number
  updatedAt: string
  url: string
  width: number
  id: number
}
/*
{"id":1942,"title":null,"description":null,"link":null,"linkText":null,
"image":{"id":2346,"name":"tufting.jpg","alternativeText":"tufting.jpg","caption":"tufting.jpg","width":910,"height":512,
"formats":{"small":{"ext":".jpg","url":"https://konfetti-cms.s3.eu-central-1.amazonaws.com/small_tufting_f2fe8ea286.jpg","hash":"small_tufting_f2fe8ea286","mime":"image/jpeg","name":"small_tufting.jpg","path":null,"size":32.85,"width":500,"height":281},
// "medium":{"ext":".jpg","url":"https://konfetti-cms.s3.eu-central-1.amazonaws.com/medium_tufting_f2fe8ea286.jpg","hash":"medium_tufting_f2fe8ea286","mime":"image/jpeg","name":"medium_tufting.jpg","path":null,"size":62.3,"width":750,"height":422},"thumbnail":{"ext":".jpg","url":"https://konfetti-cms.s3.eu-central-1.amazonaws.com/thumbnail_tufting_f2fe8ea286.jpg","hash":"thumbnail_tufting_f2fe8ea286","mime":"image/jpeg","name":"thumbnail_tufting.jpg","path":null,"size":9.92,"width":245,"height":138}},"hash":"tufting_f2fe8ea286","ext":".jpg","mime":"image/jpeg","size":84.09,"url":"https://konfetti-cms.s3.eu-central-1.amazonaws.com/tufting_f2fe8ea286.jpg","previewUrl":null,"provider":"aws-s3","provider_metadata":null,"createdAt":"2024-08-07T12:19:56.065Z","updatedAt":"2024-08-07T12:19:56.065Z","documentId":"npwb878s3za3tuo9znb2dbn3","publishedAt":"2025-04-14T17:09:40.912Z"}}

*/
const getImageUrl = (
  image: StrapiMedia,
  format: 'thumbnail' | 'small' | 'medium' | 'large' | null = null
): string => {
  const host = 'https://konfetti-cms.s3.eu-central-1.amazonaws.com/'
  const cdnHost = 'https://d1sos1r10s6do5.cloudfront.net/cms-media/'

  if (!format) {
    return image?.url?.replace(host, cdnHost)
  }

  let imgUrl = ['thumbnail', 'small', 'medium', 'large'].includes(format)
    ? image?.formats?.[format]?.url?.replace(host, cdnHost)
    : null

  // Sometimes the url attribute isn't available,
  // so we need to manually assemble that
  if (!imgUrl) {
    const formatObj = image?.formats?.[format]

    if (formatObj) {
      const hash = formatObj?.hash || ''
      const ext = formatObj?.ext || ''
      imgUrl = `${cdnHost}${hash}${ext}`
    } else {
      imgUrl = image?.url
      if (imgUrl) {
        imgUrl = imgUrl.replace(host, cdnHost)
      }
    }
  }

  return imgUrl
}

const getAlternativeText = (image: StrapiMedia): string => {
  return image?.alternativeText || ''
}

export const strapiImageGetters = {
  getImageUrl,
  getAlternativeText,
}
